<template>
  <div class="out_wrap">
    <div class="back_wrap">
      <el-button @click="$router.go(-1)"><i class="el-icon-arrow-left" />返回</el-button>
      <span class="fs16 bold ml20">角色管理</span>
    </div>
    <div class="between search">
      <div class="left flex1">
        <el-form ref="form" :model="queryControl" label-width="110px">
          <div class="form-box">
            <el-form-item label="角色名称/描述:" class="formItem">
              <el-input v-model="queryControl.keyword" type="text" placeholder="请输入角色名称/描述" clearable @keyup.native.enter="query(1)" />
            </el-form-item>
            <div>
              <el-button type="primary" @click="query(1)">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="right">
        <el-button type="primary" @click="create"><i class="el-icon-plus" />新增角色</el-button>
      </div>
    </div>
    <zf-table
      :columns="columnRole"
      :data-source="tableData"
      :total="pageControl.total"
      :page-size="pageControl.pageSize"
      :page-num="pageControl.pageNumber"
      @change="handlePageChange"
    >
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="row.role_id != 1" class="edit" @click="edit(row)">编辑</a>
        <el-divider v-if="row.role_id != 1" direction="vertical" />
        <a v-if="row.role_id != 1" class="edit" @click="setPower(row)">权限配置</a>
        <el-divider v-if="row.role_id != 1 && row.status == 2" direction="vertical" />
        <a v-if="row.role_id != 1 && row.status == 2" class="edit" @click="setStatus(row, 1)">启用</a>
        <el-divider v-if="row.role_id != 1 && row.status == 1" direction="vertical" />
        <a v-if="row.role_id != 1 && row.status == 1" class="del" @click="setStatus(row, 2)">禁用</a>
        <el-divider v-if="row.role_id != 1" direction="vertical" />
        <a v-if="row.role_id != 1" class="del" @click="delRole(row)">删除</a>
      </template>
    </zf-table>
    <el-dialog :title="mode == 1 ? '新增角色' : '编辑角色'" :visible.sync="dialogFormVisible">
      <el-form ref="ruleForm" :model="roleOne" :rules="rules" class="demo-ruleForm" label-width="100px">
        <el-form-item label="角色名称：" prop="role_name">
          <el-input v-model="roleOne.role_name" placeholder="请输入角色名称" class="w100" clearable />
        </el-form-item>
        <el-form-item label="描述：">
          <el-input v-model="roleOne.describe" type="textarea" :rows="3" placeholder="请输入角色描述" :resize="'vertical'" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ZfTable from '@/components/ZfTable/CoreTable'
import columnRole from './columns/role'
import { roleList, roleAdd, roleEdit, roleStatus, roleDel } from '@/api/accountInfo'
export default {
  components: {
    ZfTable
  },
  data() {
    return {
      columnRole,
      queryControl: {
        keyword: ''
      },
      pageControl: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      mode: 1, // 1-新增 2-修改
      dialogFormVisible: false,
      roleOne: {},
      rules: {
        role_name: [{ required: true, message: '请输入角色名称', trigger: 'change' }]
      }
    }
  },
  created() {
    this.query(this.pageControl.pageNumber)
  },
  methods: {
    delRole(item) {
      this.$confirm('确定删除该角色吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        roleDel({ role_id: item.role_id }).then(data => {
          if (data) {
            this.$message({ type: 'success', message: '删除成功' })
            this.query(this.pageControl.pageNumber)
          }
        })
      })
    },
    query(pg) {
      this.pageControl.pageNumber = pg
      roleList({ keyword: this.queryControl.keyword, page: pg, pageSize: this.pageControl.pageSize }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.data
          this.pageControl.total = res.data.total
        }
      })
    },
    resetForm() {
      this.queryControl = {
        keyword: ''
      }
      this.query(1)
    },
    handlePageChange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.pageControl.pageSize = pageSize
      this.query(pageNum)
    },
    create() {
      this.mode = 1
      this.roleOne = {}
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(['role_name'])
      })
    },
    edit(item) {
      this.mode = 2
      this.roleOne = { ...item }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(['role_name'])
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.mode === 1) {
            roleAdd({ role_name: this.roleOne.role_name, describe: this.roleOne.describe }).then(res => {
              if (res.code === 200) {
                this.dialogFormVisible = false
                this.$message({ type: 'success', message: '新增成功' })
                this.query(this.pageControl.pageNumber)
              }
            })
          } else {
            roleEdit({ role_id: this.roleOne.role_id, role_name: this.roleOne.role_name, describe: this.roleOne.describe }).then(res => {
              if (res.code === 200) {
                this.dialogFormVisible = false
                this.$message({ type: 'success', message: '编辑成功' })
                this.query(this.pageControl.pageNumber)
              }
            })
          }
        }
      })
    },
    setPower(item) {
      this.$router.push({ path: '/account/power', query: { id: item.role_id, name: item.role_name }})
    },
    setStatus(item, type) {
      if (type === 2) {
        this.$confirm('确认禁用该角色吗？', '禁用提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          roleStatus({ role_id: item.role_id, status: type }).then(res => {
            if (res.code === 200) {
              this.$message({ type: 'success', message: '禁用成功' })
              this.query(this.pageControl.pageNumber)
            }
          })
        })
      } else {
        roleStatus({ role_id: item.role_id, status: type }).then(res => {
          if (res.code === 200) {
            this.$message({ type: 'success', message: '启用成功' })
            this.query(this.pageControl.pageNumber)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
